module.exports = __webpack_public_path__ + "img/cpanel-logo.b6a04963.svg";